import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { IProperties } from '../../../builder/types';
import { FormikErrors, FormikTouched } from 'formik';
import FormField from '../../../../../components/FormField';
import TextInput from '../../../../../components/TextInput';

interface IFillingInputProps {
  properties: IProperties,
  name: string,
  touched: FormikTouched<any>,
  errors: FormikErrors<any>
}

export const FillingInput: React.FC<IFillingInputProps> = ({ properties, name, touched, errors }, props) => {
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4} style={{userSelect: 'none'}}>
        <Text onClick={() => { }} fontWeight={500} style={{userSelect: 'none'}}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300} style={{userSelect: 'none'}}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <FormField ml={3} flex={1} mb={0} error={touched[name] && errors[name]}>
        <TextInput name={name} {...((properties || {}).params || {}).ctrlProps} {...props} style={{ height: 'fit-content' }} />
      </FormField>
    </Flex>);
}